/* eslint-disable  prefer-destructuring  */

import React from 'react';
import TreeTitle from './TreeTitle';

export const getListReadyForGet = (productList: any, cardholdersInfo?: any, lockedProductKeys: string[] = []) => {
  const isLocked = (key: string) => lockedProductKeys.includes(key);
  const iterateProductList = {
    BUSINESS_CARD:
      productList?.BUSINESS_CARD?.map((item: any) => {
        const cardInfo = cardholdersInfo?.find((ele: any) => ele?.id === item?.cardHolderValues?.id);
        return {
          ...item,
          ...cardInfo,
          title: (
            <TreeTitle
              status={item?.status}
              productKey="BUSINESS_CARD"
              nodeKey={`${item.key}`}
              value={item.firstName ? `${item.firstName} ${item.lastName}` : item.name}
              valueName={item.type}
              productLocked={isLocked('BUSINESS_CARD')}
            />
          ),
        };
      }) || [],
    CORPORATE_EXECUTIVE_CARD:
      productList?.CORPORATE_EXECUTIVE_CARD?.map((item: any) => {
        const cardInfo = cardholdersInfo?.find((ele: any) => ele?.id === item?.cardHolderValues?.id);
        return {
          ...item,
          ...cardInfo,
          title: (
            <TreeTitle
              status={item?.status}
              productKey="CORPORATE_EXECUTIVE_CARD"
              nodeKey={`${item.key}`}
              value={item.firstName ? `${item.firstName} ${item.lastName}` : item.name}
              valueName={item.type}
              productLocked={isLocked('CORPORATE_EXECUTIVE_CARD')}
            />
          ),
        };
      }) || [],
    DIGITAL_TRAVEL_PAYMENT:
      productList?.DIGITAL_TRAVEL_PAYMENT?.map((item: any) => {
        return {
          ...item,
          title: (
            <TreeTitle
              productKey="DIGITAL_TRAVEL_PAYMENT"
              nodeKey={item.key}
              value={item.name}
              valueName={item.type}
              productLocked={isLocked('DIGITAL_TRAVEL_PAYMENT')}
            />
          ),
        };
      }) || [],
    DIGITAL_BUSINESS_PAYMENT:
      productList?.DIGITAL_BUSINESS_PAYMENT?.map((item: any) => {
        return {
          ...item,
          title: (
            <TreeTitle
              productKey="DIGITAL_BUSINESS_PAYMENT"
              nodeKey={item.key}
              value={item.name}
              valueName={item.type}
              productLocked={isLocked('DIGITAL_BUSINESS_PAYMENT')}
            />
          ),
        };
      }) || [],
  };

  return iterateProductList;
};

export const listToTree = (productList: any, funType?: string) => {
  const corporativepreList = productList?.CORPORATE_EXECUTIVE_CARD?.map((item: any) => {
    const { title, key = {}, cardHolderValues, name, ...itemRest } = item;
    return {
      ...cardHolderValues,
      ...itemRest,
      uuid: undefined,
      sendInvitationCounter: undefined,
      name: item.type === 'cardholder' ? undefined : name,
    };
  });
  const businessCardList = productList?.BUSINESS_CARD?.map((item: any) => {
    const { title, key = {}, cardHolderValues, name, ...itemRest } = item;
    return {
      ...cardHolderValues,
      ...itemRest,
      uuid: undefined,
      sendInvitationCounter: undefined,
      name: item.type === 'cardholder' ? undefined : name,
    };
  });
  const digitalTravel = productList?.DIGITAL_TRAVEL_PAYMENT?.map((item: any) => {
    const cardDetails = item?.cardHolderValues || {};
    return {
      uniqueId: item.uniqueId,
      parentId: item.parentId,
      name: item.type === 'cardholder' ? undefined : item.name,
      type: item.type,
      levels: item.children,
      ...cardDetails,
      sendInvitationCounter: undefined,
    };
  });
  const digitalBusiness = productList?.DIGITAL_BUSINESS_PAYMENT?.map((item: any) => {
    const cardDetails = item?.cardHolderValues || {};
    return {
      uniqueId: item.uniqueId,
      parentId: item.parentId,
      name: item.type === 'cardholder' ? undefined : item.name,
      type: item.type,
      levels: item.children,
      ...cardDetails,
      sendInvitationCounter: undefined,
    };
  });
  const iterateProductList = {
    CORPORATE_EXECUTIVE_CARD: getTree(corporativepreList, funType)[0],
    DIGITAL_TRAVEL_PAYMENT: getTree(digitalTravel, funType)[0],
    DIGITAL_BUSINESS_PAYMENT: getTree(digitalBusiness, funType)[0],
    BUSINESS_CARD: getTree(businessCardList, funType)[0],
  };

  return iterateProductList;
};

export const getListReadyForPost = (productList: any, cardholdersInfo?: any, contactsInfo?: any) => {
  const contactRolesMap: Record<string, string[]> = {};
  const allCardTypes = ['CORPORATE_EXECUTIVE_CARD', 'BUSINESS_CARD'];

  allCardTypes.forEach((cardType) => {
    productList?.[cardType]?.forEach((item: any) => {
      const contactId = item?.cardHolderValues?.contactId || item?.contactId;
      const userRoles = item?.cardHolderValues?.userRoles || [];
      if (contactId && userRoles.length) {
        if (!contactRolesMap[contactId]) {
          contactRolesMap[contactId] = [];
        }
        userRoles.forEach((role: string) => {
          if (!contactRolesMap[contactId].includes(role)) {
            contactRolesMap[contactId].push(role);
          }
        });
      }
    });
  });

  const syncUserRoles = (item: any) => {
    const contactId = item?.cardHolderValues?.contactId || item?.contactId;
    if (contactId && contactRolesMap[contactId]) {
      if (item?.cardHolderValues) {
        item.cardHolderValues = {
          ...item.cardHolderValues,
          userRoles: contactRolesMap[contactId],
        };
      }
    }
    return item;
  };

  const cardholderContacts = contactsInfo?.find((group: any) => group?.type === 'cardholder')?.contacts || [];

  const iterateProductList = {
    CORPORATE_EXECUTIVE_CARD: productList?.CORPORATE_EXECUTIVE_CARD?.map((item: any) => {
      const cardInfo = cardholdersInfo?.find((ele: any) => ele?.id === item?.cardHolderValues?.id);

      const contactInfo = cardholderContacts.find(
        (contact: any) => contact?.contactId === item?.cardHolderValues?.contactId,
      );

      const { title, ...rest } = item;
      const syncedItem = syncUserRoles({ ...rest, ...cardInfo });
      return syncedItem;
      return {
        ...rest,
        ...cardInfo,
        ...(contactInfo?.userRoles && { userRoles: contactInfo.userRoles }),
      };
    }),
    DIGITAL_TRAVEL_PAYMENT: productList?.DIGITAL_TRAVEL_PAYMENT?.map((item: any) => {
      const { title, ...rest } = item;
      return rest;
    }),
    DIGITAL_BUSINESS_PAYMENT: productList?.DIGITAL_BUSINESS_PAYMENT?.map((item: any) => {
      const { title, ...rest } = item;
      return rest;
    }),
    BUSINESS_CARD: productList?.BUSINESS_CARD?.map((item: any) => {
      const cardInfo = cardholdersInfo?.find((ele: any) => ele?.id === item?.cardHolderValues?.id);

      const { title, ...rest } = item;
      const syncedItem = syncUserRoles({ ...rest, ...cardInfo });
      return syncedItem;
    }),
  };

  return iterateProductList;
};

export const getTree = (treeListValues: any, funType?: string) => {
  const nest = (items: any, uniqueId = null, link = 'parentId') =>
    items
      ?.filter((item: any) => item[link] === uniqueId)
      ?.map((item: any) => {
        const nextLevelData = nest(items, item?.uniqueId);
        const { parentId, uniqueId, id, applicationId, cardHolderValues, ...itemRest } = item;
        if (funType) {
          return {
            ...item,

            levels: nextLevelData?.length ? nextLevelData : undefined,
          };
        }
        return {
          ...itemRest,
          ...cardHolderValues,
          levels: nextLevelData?.length ? nextLevelData : undefined,
        };
      });

  return nest(treeListValues) ?? [];
};

export const getProductsOrder = (productKey: string) => {
  switch (productKey) {
    case 'CORPORATE_EXECUTIVE_CARD':
      return 1;
    case 'DIGITAL_BUSINESS_PAYMENT':
      return 2;
    case 'DIGITAL_TRAVEL_PAYMENT':
      return 3;
    case 'BUSINESS_CARD':
      return 4;

    default:
      break;
  }
  return 0;
};

export const getLeafNodes = (values: any, result: any = []) => {
  const results = listToTree(values, 'test');
  function getLeafsObjs(nodes: any, result: any = []) {
    for (let i = 0, length = nodes?.length; i < length; i++) {
      if ((!nodes[i]?.levels || nodes[i]?.levels?.length === 0) && nodes[i]?.type !== 'cardholder') {
        result?.push(nodes[i]);
      } else {
        result = getLeafsObjs(nodes[i].levels, result);
      }
    }
    return result;
  }

  const productsLeafs = {
    CORPORATE_EXECUTIVE_CARD: getLeafsObjs([results?.CORPORATE_EXECUTIVE_CARD]),
    DIGITAL_TRAVEL_PAYMENT: getLeafsObjs([results?.DIGITAL_TRAVEL_PAYMENT]),
    DIGITAL_BUSINESS_PAYMENT: getLeafsObjs([results?.DIGITAL_BUSINESS_PAYMENT]),
    BUSINESS_CARD: getLeafsObjs([results?.BUSINESS_CARD]),
  };
  return productsLeafs;
};

export const getinitialProductList = (selectedProducts: any) => {
  const initialObj: any = {};
  selectedProducts.map((item: any) => {
    if (item.enabled) {
      initialObj[item?.id] = [];
    }
    return item;
  });

  return initialObj;
};
